import React from 'react';
import classNames from 'classnames';

import { getMapClassname } from 'app/views/hybrid/utils/map';
import CloudItem from 'app/views/hybrid/maps/components/CloudItem';
import CloudIcon from 'app/views/hybrid/maps/components/CloudIcon';
import MinifiedCloudItem from 'app/views/hybrid/maps/components/MinifiedCloudItem';
import { ICON_SIZE, DIRECT_CONNECT_HEIGHT, DIRECT_CONNECT_WIDTH } from 'app/views/hybrid/utils/cloud/constants';

const GCPCloudItem = ({
  onClick,
  className,
  width = DIRECT_CONNECT_WIDTH,
  height = DIRECT_CONNECT_HEIGHT,
  isHighlighted = false,
  title,
  subtitle,
  type,
  entity,
  iconsToDisplay = [],
  ...rest
}) => {
  const icon = <CloudIcon cloudProvider="gcp" entity={type} width={ICON_SIZE} height={ICON_SIZE} />;
  const { id } = entity;

  const heightWithIcons = iconsToDisplay.length > 0 ? height * 2 : height;

  return (
    <MinifiedCloudItem
      className={classNames(getMapClassname({ type, value: id }), className, { flashing: isHighlighted })}
      icon={icon}
      title={subtitle}
      strokeWidth={2}
      pointerEvents="auto"
      backgroundHighlightColor="primaryBackground"
      isMinified={false}
      {...rest}
      onClickCapture={onClick} // enable capture phase because CloudItem swallows click events
    >
      <svg width={width + 2} height={heightWithIcons + 2} viewBox={`-1 -1 ${width + 2} ${heightWithIcons + 2}`}>
        <CloudItem
          className={classNames({ flashing: isHighlighted })}
          stroke="primary"
          itemHoverFill={null}
          width={width}
          height={heightWithIcons}
          icon={icon}
          title={title}
          subtitle={subtitle}
          innerProps={{ height }}
          strokeDasharray="unset"
          iconsToDisplay={iconsToDisplay}
        />
      </svg>
    </MinifiedCloudItem>
  );
};

export default GCPCloudItem;
